module.exports = __webpack_public_path__ + "static/img/3.dd0dc1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/3.png
// module id = T8Fu
// module chunks = 0